import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appAdWidget]',
})
export class WidgetDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
